/**
 * "Alterar minha senha" — usuário logado troca a própria senha sem depender do
 * e-mail de recuperação (o endpoint existia, faltava a tela). Fica no cabeçalho.
 */
import React, { useState } from 'react';
import { Eye, EyeOff, KeyRound } from 'lucide-react';
import toast from 'react-hot-toast';
import { authAPI } from '../services/api';

export default function AlterarSenhaModal({ aberto, onClose }) {
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  if (!aberto) return null;

  const fechar = () => { setAtual(''); setNova(''); setConfirmar(''); setErro(''); onClose(); };

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    if (!atual) return setErro('Informe a senha atual.');
    if (nova.length < 6) return setErro('A nova senha deve ter no mínimo 6 caracteres.');
    if (nova === atual) return setErro('A nova senha deve ser diferente da atual.');
    if (nova !== confirmar) return setErro('As senhas não conferem.');
    setSalvando(true);
    try {
      await authAPI.changePassword(atual, nova);
      toast.success('Senha alterada. Use a nova senha no próximo acesso.');
      fechar();
    } catch (err) {
      setErro(err.response?.data?.detail || 'Não foi possível alterar a senha.');
    } finally {
      setSalvando(false);
    }
  };

  const campo = (rotulo, valor, setValor, id, placeholder) => (
    <div className="form-group">
      <label htmlFor={id}>{rotulo}</label>
      <input id={id} type={mostrar ? 'text' : 'password'} className="form-control" value={valor}
        onChange={(e) => setValor(e.target.value)} placeholder={placeholder} autoComplete={id === 'senhaAtual' ? 'current-password' : 'new-password'} />
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: 440 }}>
        <div className="modal-header">
          <h3 style={{ display: 'flex', alignItems: 'center', gap: 8 }}><KeyRound size={18} /> Alterar minha senha</h3>
          <button className="modal-close" onClick={fechar}>&times;</button>
        </div>
        <form onSubmit={salvar}>
          {erro && <div className="alert alert-error">{erro}</div>}
          {campo('Senha atual', atual, setAtual, 'senhaAtual', 'Sua senha de hoje')}
          {campo('Nova senha', nova, setNova, 'senhaNova', 'Mínimo 6 caracteres')}
          {campo('Confirmar nova senha', confirmar, setConfirmar, 'senhaConfirmar', 'Repita a nova senha')}
          <div style={{ marginBottom: '0.75rem' }}>
            <label htmlFor="mostrarSenhas" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: '0.85rem', color: 'var(--gray-700, #333)', cursor: 'pointer', fontWeight: 400 }}>
              <input id="mostrarSenhas" type="checkbox" checked={mostrar} onChange={(e) => setMostrar(e.target.checked)} style={{ margin: 0 }} />
              {mostrar ? <EyeOff size={14} /> : <Eye size={14} />}
              <span>Mostrar senhas</span>
            </label>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={fechar} disabled={salvando}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando…' : 'Alterar senha'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
